<template>
  <div class="create-form">
    <!-- 新闻 云采集 -->
    <News v-if="type === 'news' || type === 'api'" />
    <!-- 文献 -->
    <Document v-else-if="type === 'document'"></Document>
    <!-- 微信公众号 -->
    <Wechat v-else-if="type === 'wechat'" />

    <div class="type-box">
      <img :src="require(`./img/${$route.query.type}.png`)" alt="" />
      <p>{{ nameMap[$route.query.type] }}</p>
    </div>
  </div>
</template>
<script>
import News from './News/'
import WeMedia from './WeMedia/'
import Toutiao from './Toutiao'
import Document from './Document'
import Wechat from './Wechat'

export default {
  components: {
    News,
    WeMedia,
    Toutiao,
    Document,
    Wechat
  },
  data() {
    return {
      type: '',
      nameMap: {
        news: '新闻',
        facebook: 'Facebook',
        toutiao: '头条',
        twitter: '推特',
        weibo: '微博',
        youtube: 'Youtube',
        api: '云采集',
        document: '文献',
        tg: 'telegram',
        ins: 'Instagram',
        vk: 'vk',
        wechat: '微信公众号'
      }
    }
  },
  created() {
    let { type } = this.$route.query
    if (type) {
      this.type = type
    }
  }
}
</script>

<style lang="less" scoped>
.create-form {
  padding: 25px;
  position: relative;
}
.type-box {
  width: 200px;
  position: absolute;
  text-align: center;
  right: 0px;
  top: 60px;
  img {
    width: 106px;
    height: 106px;
    margin-bottom: 15px;
    box-shadow: 0px 10px 12px 0px rgba(0, 0, 0, 0.18);
    border-radius: 8px;
  }
  p {
    font-size: 22px;
    font-weight: bold;
    color: #333;
  }
}
</style>
